"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectAlertByRef = exports.selectAlertsMap = exports.selectAlertByWidgetRef = exports.selectAlerts = void 0;
var tslib_1 = require("tslib");
// (C) 2021-2023 GoodData Corporation
var toolkit_1 = require("@reduxjs/toolkit");
var alertsEntityAdapter_1 = require("./alertsEntityAdapter");
var objRefMap_1 = require("../../../_staging/metadata/objRefMap");
var compact_1 = tslib_1.__importDefault(require("lodash/compact"));
var memoize_1 = tslib_1.__importDefault(require("lodash/memoize"));
var sdk_model_1 = require("@gooddata/sdk-model");
var layoutSelectors_1 = require("../layout/layoutSelectors");
var selectSelf = toolkit_1.createSelector(function (state) { return state; }, function (state) { return state.alerts; });
var adapterSelectors = alertsEntityAdapter_1.alertsAdapter.getSelectors(selectSelf);
/**
 * Selects all alerts used on the dashboard.
 *
 * @alpha
 */
exports.selectAlerts = adapterSelectors.selectAll;
/**
 * Selects all alerts and returns them in a mapping of widget obj ref to the alert object.
 *
 * @internal
 */
var selectAlertsMapByWidgetRefs = toolkit_1.createSelector(exports.selectAlerts, layoutSelectors_1.selectWidgetsMap, function (alerts, widgetsMap) {
    var mappedItems = compact_1.default(alerts.map(function (alert) {
        var widget = widgetsMap.get(alert.widget);
        if (!widget) {
            /**
             * Ignore widgets that are no longer available, this can naturally happen in edit mode when
             * a KPI widget is deleted by the user: the alerts are not removed from redux in case the edit
             * mode is cancelled (to avoid having to load the dashboard again from the backend).
             */
            return undefined;
        }
        var result = {
            identifier: widget.identifier,
            uri: widget.uri,
            ref: widget.ref,
            alert: alert,
        };
        return result;
    }));
    return objRefMap_1.newMapForObjectWithIdentity(mappedItems);
});
/**
 * Selects alert or undefined by widget ref
 *
 * @alpha
 */
exports.selectAlertByWidgetRef = memoize_1.default(function (widgetRef) {
    return toolkit_1.createSelector(selectAlertsMapByWidgetRefs, function (alerts) {
        var alert = alerts.get(widgetRef);
        if (alert) {
            return alert.alert;
        }
    });
}, sdk_model_1.serializeObjRef);
/**
 * Selects dashboard alerts in mapping an obj ref to widget map.
 *
 * @internal
 */
exports.selectAlertsMap = toolkit_1.createSelector(exports.selectAlerts, function (alerts) {
    return objRefMap_1.newMapForObjectWithIdentity(alerts);
});
/**
 * Selects alert or undefined by alert ref
 *
 * @alpha
 */
exports.selectAlertByRef = memoize_1.default(function (ref) {
    return toolkit_1.createSelector(exports.selectAlertsMap, function (alerts) {
        return alerts.get(ref);
    });
}, sdk_model_1.serializeObjRef);
//# sourceMappingURL=alertsSelectors.js.map